interface Kosapo {
  auOnlineExchange: string;
  custodyRepair: string;
  auShopSearch: string;
  auOnlineShop: string;
  kfsCenter: string;
  kfsCenterTroubleShooting: string;
  tsukasapoCenter: string;
  appleSupportNumber: string;
  appleSupport: string;
  storeRepair: string;
  kfsWithAcs: string;
  appleSupportRepairNumber: string;
  auCustomerSupport: string;
  auCustomerSupportFromOthers: string;
  auSupportInquiry: string;
  auCustomerSupportNonTsukasapo: string;
  auCustomerSupportOtherNonTsukasapo: string;
  uqOnlineExchange: string;
  uqCustodyRepair: string;
  uqShopSearch: string;
  uqOnlineShop: string;
  uqCustomerSupportNumberBrokenLost: string;
  uqCustomerSupportNumber: string;
  uqCustomerSupport: string;
  povoCustomerSupport: string;
  povoTroubleSupport: string;
}

const state: Kosapo = {
  auOnlineExchange: 'https://www.au.com/support/service/mobile/trouble/repair/application/',
  custodyRepair: 'https://www.au.com/support/service/mobile/trouble/repair/application/azukari/',
  auShopSearch: 'https://www.au.com/aushop/',
  auOnlineShop: 'https://www.au.com/mobile/onlineshop/',
  kfsCenter: '0120-925-691',
  kfsCenterTroubleShooting: '0120-925-692',
  tsukasapoCenter: '0120-925-695',
  appleSupportNumber: '0120-277-535',
  appleSupport: 'https://support.apple.com/ja-jp',
  storeRepair: 'https://www.au.com/support/service/mobile/trouble/repair-iphone-ipad/service/',
  kfsWithAcs: '0120-925-050',
  appleSupportRepairNumber: 'https://support.apple.com/ja-jp/repair',
  auCustomerSupport: '113',
  auCustomerSupportFromOthers: '0077-7-113',
  auSupportInquiry: 'https://www.au.com/support/inquiry/',
  auCustomerSupportNonTsukasapo: '157',
  auCustomerSupportOtherNonTsukasapo: '0120-977-033',
  uqOnlineExchange: 'https://www.uqwimax.jp/mobile/support/trouble/repair/application/',
  uqCustodyRepair: 'https://www.uqwimax.jp/mobile/support/trouble/',
  uqShopSearch: 'https://www.uqwimax.jp/mobile/shoplist/',
  uqOnlineShop: 'https://shop.uqmobile.jp/shop/',
  uqCustomerSupportNumberBrokenLost: '0120-466-446',
  uqCustomerSupportNumber: '0120-929-818',
  uqCustomerSupport: 'https://www.uqwimax.jp/mobile/support/contact/',
  povoCustomerSupport: 'https://povo.au.com/support/',
  povoTroubleSupport: 'https://povo.au.com/support/trouble/loss/'
};

const getters = {
  auOnlineExchange (moduleState: Kosapo) {
    return moduleState.auOnlineExchange;
  },
  custodyRepair (moduleState: Kosapo) {
    return moduleState.custodyRepair;
  },
  auShopSearch (moduleState: Kosapo) {
    return moduleState.auShopSearch;
  },
  auOnlineShop (moduleState: Kosapo) {
    return moduleState.auOnlineShop;
  },
  kfsCenter (moduleState: Kosapo) {
    return moduleState.kfsCenter;
  },
  kfsCenterTroubleShooting (moduleState: Kosapo) {
    return moduleState.kfsCenterTroubleShooting;
  },
  tsukasapoCenter (moduleState: Kosapo) {
    return moduleState.tsukasapoCenter;
  },
  appleSupportNumber (moduleState: Kosapo) {
    return moduleState.appleSupportNumber;
  },
  appleSupport (moduleState: Kosapo) {
    return moduleState.appleSupport;
  },
  storeRepair (moduleState: Kosapo) {
    return moduleState.storeRepair;
  },
  kfsWithAcs (moduleState: Kosapo) {
    return moduleState.kfsWithAcs;
  },
  appleSupportRepairNumber (moduleState: Kosapo) {
    return moduleState.appleSupportRepairNumber;
  },
  auCustomerSupport (moduleState: Kosapo) {
    return moduleState.auCustomerSupport;
  },
  auCustomerSupportFromOthers (moduleState: Kosapo) {
    return moduleState.auCustomerSupportFromOthers;
  },
  auSupportInquiry (moduleState: Kosapo) {
    return moduleState.auSupportInquiry;
  },
  auCustomerSupportNonTsukasapo (moduleState: Kosapo) {
    return moduleState.auCustomerSupportNonTsukasapo;
  },
  auCustomerSupportOtherNonTsukasapo (moduleState: Kosapo) {
    return moduleState.auCustomerSupportOtherNonTsukasapo;
  },
  uqOnlineExchange (moduleState: Kosapo) {
    return moduleState.uqOnlineExchange;
  },
  uqCustodyRepair (moduleState: Kosapo) {
    return moduleState.uqCustodyRepair;
  },
  uqShopSearch (moduleState: Kosapo) {
    return moduleState.uqShopSearch;
  },
  uqOnlineShop (moduleState: Kosapo) {
    return moduleState.uqOnlineShop;
  },
  uqCustomerSupportNumberBrokenLost (moduleState: Kosapo) {
    return moduleState.uqCustomerSupportNumberBrokenLost;
  },
  uqCustomerSupportNumber (moduleState: Kosapo) {
    return moduleState.uqCustomerSupportNumber;
  },
  uqCustomerSupport (moduleState: Kosapo) {
    return moduleState.uqCustomerSupport;
  },
  povoCustomerSupport (moduleState: Kosapo) {
    return moduleState.povoCustomerSupport;
  },
  povoTroubleSupport (moduleState: Kosapo) {
    return moduleState.povoTroubleSupport;
  }
};

export const kosapo = {
  state,
  getters
};
